export default __webpack_public_path__ + "images/4cfb230b7ab570109bbaffdbbdb73e74-home_and_garden.webp";